import React from "react";
import PropTypes from "prop-types";
import styleObjectToProps from "core-web/utils/styleObjectToProps";
import styled from "theme/libs/styled";

const Wrapper = styled("div")`
    margin-bottom: 32px;

    & > * {
        margin-bottom: 8px;
    }

    ul,
    ol {
        padding-left: 16px;
    }

    ul li,
    ol li {
        margin-bottom: 4px;
    }
`;

const TextComponent = ({ className, html, textStyle }) => {
    const textStyles = styleObjectToProps(textStyle);

    return <Wrapper {...textStyles} className={className} dangerouslySetInnerHTML={{ __html: html }} />;
};

TextComponent.propTypes = {
    className: PropTypes.string,
    html: PropTypes.string.isRequired,
    textStyle: PropTypes.string,
};

TextComponent.defaultProps = {
    className: "",
    textStyle: "Avenir/16-140 Medium",
};
export default TextComponent;
